"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = config;
var _conf = _interopRequireDefault(require("./conf"));
var _domZindex = _interopRequireDefault(require("dom-zindex"));
var _xeUtils = _interopRequireDefault(require("xe-utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 全局参数设置
 */
function config(options) {
  if (options && options.zIndex) {
    _domZindex.default.setCurrent(options.zIndex);
  }
  return _xeUtils.default.merge(_conf.default, options);
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vxe-table@3.7.6/~/vxe-table/lib/v-x-e-table/src/config.js
// module id = 1025
// module chunks = 75